/* eslint-disable import/prefer-default-export */
import { track } from '../instrumentation/Track';

export const trackClickSelectCustomer = (fields = {}) =>
  track('track_click_select_customer', fields);
